export default {"src":"/_next/static/media/PediatricOrthopedicIssues.4a4b7695.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};